import React, { useState } from "react";
import {
  Row,
  Card,
  CardBody,
  Input,
  CardTitle,
  FormGroup,
  Label,
  Form,
  Table,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
} from "reactstrap";
// import Button from "../../../../../buttoncomponent/StyledButton";
import TeamanicsButton from "../../../../../buttoncomponent/TeamanicsButton";
import { Colxx } from "../../../../../components/common/CustomBootstrap";
import { useEffect } from "react";
import "react-datepicker/dist/react-datepicker.css";
import "react-circular-progressbar/dist/styles.css";
import "react-perfect-scrollbar/dist/css/styles.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-image-lightbox/style.css";
import "video.js/dist/video-js.css";
import "../../../../../assets/css/bootStrap/bootstrap.min.css"
import "../../../../../assets/css/overridestyles.css";
import { useHistory } from "react-router-dom";

import { ProfileService } from "../../../../../services/ProfileService";
import { Stringutility } from "../../../../../utilities/stringutility";
import { Constants } from "../../../../../constants/constantValues";

const Resume = () => {
  const history = useHistory();
  const [fileType, setFileType] = useState("");
  const [resumes, setResumes] = useState([]);
  const [documents, setDocuments] = useState([]);
  const [fileTypes, setFileTypes] = useState([]);
  const [modalRight, setModalRight] = useState(false);
  const [modalLong, setModalLong] = useState(false);
  const [documentId, setDocumentId] = useState("");
  const [documentName, setDocumentName] = useState("");
  localStorage.setItem('deleteIconVisible', 'true');
  const isDeleteIconVisible = localStorage.getItem('deleteIconVisible') === 'true';
  const [inputField, setInputField] = useState({
    name: "",
    description: "",
    documentName: "",
    documentDescription: "",
    email: "",
    primaryPhone: "",
    secondaryNumber: "",
    additionalPublicInfoDesc: "",
    internalNoteDesc: "",
    zipCode: "",
    position: "",
  });

  const inputsHandler = (e) => {
    const { name, value } = e.target;
    setInputField((prevState) => ({
      ...prevState,
      [name]: value,
    }));
  };

  const handleCancelButton = () => {
    history.push("/smartresume");
  };

  const handleFileTypeSelectChange = (e) => {
    setFileType(e.target.value);
  };

  const onAddResume = () => {
    setModalRight(true);
  };

  const ondeleteResume = (deleteId, name, filetype) => {
    setModalLong(true);
    setDocumentId(deleteId);
    setDocumentName(name);
    setFileType(filetype);
  };

  const cancelModel = () => {
    setModalRight(false);

    setModalLong(false);
    document.getElementById("docfile").value = null;
    setFileType("");
    setInputField((prevState) => ({
      ...prevState,
      name: "",
      description: "",
    }));
  };

  useEffect(() => {
    if (!Stringutility.isNullOrEmpty(window.localStorage.getItem("enumsLists"))) {
      var enumsLists = JSON.parse(window.localStorage.getItem("enumsLists"));
      if (enumsLists.fileTypes != null) {
        setFileTypes(enumsLists.fileTypes);
      }
    }
    getCandidateDocuments();
  }, []);

  const getCandidateDocuments = () => {
    ProfileService.getDocuments().then((response) => {
      try {
        if (response.data !== null) {
          if (response.data.files.length > 0) {
            var resumesList = [];
            var documentsList = [];
            const documentDataList = response.data.files;
            documentDataList.map((document) => {
              if (document.fileType.key == "RESUME") {
                resumesList.push(document);
              } else {
                documentsList.push(document);
              }
            });
            setResumes(resumesList);
            setDocuments(documentsList);
          } else {
            setResumes([]);
            setDocuments([]);
          }
        }
      } catch (err) {
        console.error("getDocuments" + JSON.stringify(err));
      }
    });
  };

  const deleteResume = () => {
    ProfileService.deleteDocument(documentId).then((response) => {
      try {
        if (response.data != null) {
          // toast.success("File deleted successfully");
          getCandidateDocuments();
          setModalLong(false);
        }
      } catch (err) {
        console.error("deleteDocument" + JSON.stringify(err));
      }
    });
  };

  const uploadResume = () => {
    if (Stringutility.isNullOrEmpty(inputField.name)) {
      Stringutility.showErrorMessage(Constants.enterName);
      return;
    }

    if (Stringutility.isNullOrEmpty(fileType)) {
      Stringutility.showErrorMessage(Constants.selectFileType);
      return;
    }

    let file = document.getElementById("resume-docfile").files[0];
    if (file === undefined) {
      Stringutility.showErrorMessage(Constants.selectFileToUpload);
      return;
    }

    let fd = new FormData();
    fd.append("file", file);
    fd.append("fileName", inputField.name);
    fd.append("fileType", fileType);
    fd.append("description", inputField.description);

    ProfileService.uploadDocument(fd).then((response) => {
      try {
        if (response.data != null) {
          setInputField((prevState) => ({
            ...prevState,
            name: "",
            description: "",
          }));
          if (fileType === "RESUME") {
            setFileType("");
            // toast.success(
            //   "Your resume is parsed successfully. please review it later."
            // );
          } else {
            setFileType("");
            // toast.success("Your document has been uploaded succesfully.");
          }
          getCandidateDocuments();
          setModalRight(false);
          setModalLong(false);
          document.getElementById("docfile").value = null;
          setFileType("");
          setInputField((prevState) => ({
            ...prevState,
            name: "",
            description: "",
          }));
        }
      } catch (err) {
        console.error("uploadDocument" + JSON.stringify(err));
      }
    });
  };

  return (
    <>
     <div className="myProfileColumn 
    min-md:col-span-full min-lg:col-span-3 min-2xl:col-span-2 max-md:col-span-full
    min-lg:order-1 max-lg:order-2 t-profile-mb
">

                   
                    
                    <div className="myProfile-container relative  min-sm:grid-cols-3 min-sm:auto-rows-max min-sm:auto-cols-max gap-0 max-sm:mb-16 max-sm:pb-12 bg-primary-white min-sm:rounded-xl shadow-lg t-profile-padding ">
          <div className="col-sm-12 ">
            <div className="barmenu_content">
              <div>
                <div className="addexperience right">
                  <div className="skill-header">
                    <div>
                      <div className="profile-card-title">
                        
                          <h2 className="t-h2-font-sm">
                            <strong>Resume Upload (Optional)</strong>
                          </h2>
                      </div>
                      <label>Upload a resume / files.</label>
                      <div className="horizontal_line" />
                    </div>
                    <div className="mb-2 mt-3">
                      <TeamanicsButton onClick={onAddResume}>
                        Upload Resume / File
                      </TeamanicsButton>
                    </div>
                  </div>

                  <div>
                    <Modal
                      isOpen={modalRight}
                      toggle={() => setModalRight(!modalRight)}
                      wrapClassName="modal-right"
                      className="file-model-width"
                    >
                      <ModalHeader>
                        <div className=" center-title">
                          <label>Upload Resume / File</label>
                        </div>
                      </ModalHeader>
                      <ModalBody>
                        <Row>
                          <Colxx xxs="12">
                            <Row className="mb-1">
                              <Colxx xxs="12">
                                <Form>
                                  <FormGroup row>
                                    <Label sm={3}>Name*</Label>
                                    <Colxx sm={9}>
                                      <Input
                                        className="t-rounded-lg"
                                        type="text"
                                        name="name"
                                        id="resume-name"
                                        placeholder="Name"
                                        onChange={inputsHandler}
                                        value={inputField.name}
                                      ></Input>
                                    </Colxx>
                                  </FormGroup>

                                  <FormGroup row>
                                    <Label sm={3}>File Type*</Label>
                                    <Colxx sm={9}>
                                      <Input
                                        className="t-rounded-lg"
                                        value={fileType}
                                        type="select"
                                        onChange={handleFileTypeSelectChange}
                                        defaultValue={"DEFAULT"}
                                      >
                                        <option value="">Please Select</option>
                                        {fileTypes.length > 0 &&
                                          fileTypes.map(({ value, key }) => (
                                            <option value={key} key={key}>
                                              {value}
                                            </option>
                                          ))}
                                      </Input>
                                    </Colxx>
                                  </FormGroup>
                                  <FormGroup row>
                                    <Label sm={3}>Description </Label>
                                    <Colxx sm={9}>
                                      <Input
                                        rows="3"
                                        className="t-rounded-lg"
                                        id="resume-description"
                                        type="textarea"
                                        maxLength="255"
                                        name="description"
                                        onChange={inputsHandler}
                                        value={inputField.description}
                                      />
                                    </Colxx>
                                  </FormGroup>

                                  <FormGroup row>
                                    {fileType === "RESUME" ? (
                                      <Colxx sm={12}>
                                        <Input
                                          type="file"
                                          id="resume-docfile"
                                          className="form-control t-rounded-lg"
                                          placeholder="Select file"
                                          accept="application/pdf,.doc,.docx"
                                          style={{ height: "15.1vh" }}
                                        />
                                        *
                                        <Label>
                                          Size limit: 32 MBytes per file / 32
                                          MBytes total.
                                        </Label>
                                      </Colxx>
                                    ) : (
                                      <Colxx sm={12}>
                                        <Input
                                          type="file"
                                          id="resume-docfile"
                                          className="form-control"
                                          placeholder="Select file"
                                          style={{ height: "6.1vh" }}
                                        />
                                        <Label>
                                          Size limit: 32 MBytes per file / 32
                                          MBytes total.
                                        </Label>
                                      </Colxx>
                                    )}
                                  </FormGroup>
                                </Form>
                              </Colxx>
                            </Row>
                          </Colxx>
                        </Row>
                      </ModalBody>
                      <ModalFooter className="t-modal-footer-btn">
                      <TeamanicsButton 
                          onClick={() => {
                            cancelModel();
                          }}
                        >
                          Cancel
                        </TeamanicsButton>
                        <TeamanicsButton
                          onClick={uploadResume}
                        >
                          Save
                        </TeamanicsButton>{" "}
                        
                      </ModalFooter>
                    </Modal>
                  </div>
                  {resumes.length > 0 && (
                    <Row className="mb-2 mt-3">
                      <Colxx xxs="12">
                        <Card className="mb-4 t-rounded-lg">
                          <CardBody className="t-body-card-upload">
                            <CardTitle className="t-title-color-lightblue t-card-title-pad">
                              Resumes
                            </CardTitle>
                            <Table className="tab_wid">
                              <tbody>
                                {resumes.length > 0 ? (
                                  resumes.map((file, index) => {
                                    return (
                                      <tr key={index}>
                                        <td className="t-wid-tb">
                                          {file.name}
                                        </td>
                                        {/* <td>{file.fileType.value}</td> */}
                                        <td className="t-wid1-tb"></td>
                                        <td className="t-wid2-tb">
                                          <>
                                            <div className="col">
                                              <div className="row">
                                                <div className="mr-2">
                                                  <a href={file.fileKey}>
                                                    <i
                                                      className="simple-icon-cloud-download edit-copyiconsize arrow-icon-color "
                                                      title="Download Resume"
                                                      color="black"
                                                    />
                                                  </a>
                                                </div>
{isDeleteIconVisible && (
                                                <div className="t-hand-cursor-pointer">
                                                  <i
                                                    className="simple-icon-trash edit-copyiconsize arrow-icon-color "
                                                    title="Delete Resume"
                                                    onClick={() =>
                                                      ondeleteResume(
                                                        file.id,
                                                        file.name
                                                      )
                                                    }
                                                  ></i>
                                                </div>)}
                                              </div>
                                              <span></span>{" "}
                                            </div>
                                          </>
                                        </td>
                                      </tr>
                                    );
                                  })
                                ) : (
                                  <label>No data found</label>
                                )}
                              </tbody>
                            </Table>
                          </CardBody>
                        </Card>
                      </Colxx>
                    </Row>
                  )}

                  {documents.length > 0 && (
                    <Row >
                      <Colxx xxs="12">
                        <Card className="mb-4 t-rounded-lg ">
                          <CardBody className="t-body-card-upload">
                            <CardTitle className="t-title-color-lightblue t-card-title-pad">
                              Uploaded Documents
                            </CardTitle>
                            <Table className="tab_wid">
                              <thead>
                                <tr>
                                  <th className="t-wid-tb">File Name</th>
                                  <th className="t-wid1-tb">File Type</th>
                                  <th className="t-wid2-tb">Actions</th>
                                </tr>
                              </thead>
                              <tbody>
                                {documents.length > 0 ? (
                                  documents.map((file, index) => (
                                    <tr key={index}>
                                      <td>{file.name}</td>
                                      <td>{file.fileType.value}</td>
                                      <td>
                                        <>
                                          <div className="col">
                                            <div className="row">
                                              <div className="mr-2">
                                                <span>
                                                  <a href={file.fileKey}>
                                                    <i
                                                      title="Download Resume"
                                                      name="download"
                                                      theme="light"
                                                      color="black"
                                                      className="simple-icon-cloud-download edit-copyiconsize arrow-icon-color "
                                                    />
                                                  </a>
                                                </span>
                                              </div>

                                              <div className="">
                                                <i
                                                  type="button"
                                                  title="Delete Resume"
                                                  data-toggle="modal"
                                                  data-target="#exampleModal"
                                                  className="simple-icon-trash ic-profile delete-icon emp_icon"
                                                  onClick={() =>
                                                    ondeleteResume(
                                                      file.id,
                                                      file.name
                                                    )
                                                  }
                                                />
                                              </div>
                                            </div>
                                          </div>
                                        </>
                                      </td>
                                    </tr>
                                  ))
                                ) : (
                                  <Row className="float-right">
                                    <label>No data found</label>
                                  </Row>
                                )}
                              </tbody>
                            </Table>
                          </CardBody>
                        </Card>
                      </Colxx>
                    </Row>
                  )}
                </div>
              </div>
            </div>
          </div>
          {(resumes.length > 0 ||documents.length > 0)?(<>
            <TeamanicsButton
            className="ml-3"
            onClick={handleCancelButton }
          >
            Cancel
          </TeamanicsButton>
          <TeamanicsButton
            className="ml-2"
            onClick={handleCancelButton}
          >
            Save
          </TeamanicsButton>
          </>):(<></>)}
         
        </div>
        <Modal isOpen={modalLong} toggle={() => setModalLong(!modalLong)}>
          <ModalHeader>
            {" "}
            <strong>Delete document</strong>
          </ModalHeader>
          <ModalBody>
            <label>
              Do you want to delete
              {" " + documentName} document?
            </label>
          </ModalBody>
          <ModalFooter className="t-modal-footer-btn">
            <TeamanicsButton onClick={() => setModalLong(false)}>
              Close
            </TeamanicsButton>{" "}
            <TeamanicsButton
              onClick={() => {
                deleteResume();
              }}
            >
              Delete
            </TeamanicsButton>{" "}
          </ModalFooter>
        </Modal>
      </div>
    </>
  );
};

export default Resume;
